import { Component, Input } from '@angular/core';

import { PILL_COLOR_STYLE } from './pill-color-style';

@Component({
  selector: 'ls-pill',
  templateUrl: './pill.component.html',
  styleUrls: ['./pill.component.scss']
})
export class PillComponent {
  @Input()
  public count = 0;
  @Input()
  public pillColorStyle: string = PILL_COLOR_STYLE.INFO;
}
